export default "__VITE_ASSET__BFmQhTEg__"